export const GET_PROCESSING_START = 'GET_PROCESSING_START';
export const GET_PROCESSING_START_SUCCESS = 'GET_PROCESSING_START_SUCCESS';
export const GET_PROCESSING_START_FAIL = 'GET_PROCESSING_START_FAIL';

export const GET_PROCESSING_START_CANCEL = 'GET_PROCESSING_START_CANCEL';
export const GET_PROCESSING_START_CANCEL_SUCCESS = 'GET_PROCESSING_START_CANCEL_SUCCESS';
export const GET_PROCESSING_START_CANCEL_FAIL = 'GET_PROCESSING_START_CANCEL_FAIL';

export const GET_PROCESSING_START_CLEAR = 'GET_PROCESSING_START_CLEAR';

export const GET_AWAITING_PROCESSING_START = 'GET_AWAITING_PROCESSING_START';
export const GET_AWAITING_PROCESSING_START_SUCCESS = 'GET_AWAITING_PROCESSING_START_SUCCESS';
export const GET_AWAITING_PROCESSING_START_FAIL = 'GET_AWAITING_PROCESSING_START_FAIL';
